var map = {
	"./tmpl": 10
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5;



/*****************
 ** WEBPACK FOOTER
 ** ./parsing/context/templates ^\.\/t.*l$
 ** module id = 5
 ** module chunks = 0
 **/